import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from "@/contexts/AuthContext"
import { TooltipProvider } from "@/components/ui/tooltip"
import { Toaster } from "@/components/ui/toaster"
import ErrorBoundary from "@/components/ErrorBoundary"
import { getConfig, isDevelopment } from "@/utils/environment"
import App from './App.tsx'
import './index.css'
import { logger } from '@/utils/logger';

const config = getConfig();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: config.api.retryAttempts,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
    mutations: {
      retry: 1,
    },
  },
})

// Global error handlers
window.addEventListener('unhandledrejection', (event) => {
  if (isDevelopment()) {
    logger.error('Unhandled promise rejection:', event.reason);
  }
  // In production, you might want to send this to an error reporting service
});

window.addEventListener('error', (event) => {
  if (isDevelopment()) {
    logger.error('Global error:', event.error);
  }
});

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <TooltipProvider>
            <App />
            <Toaster />
          </TooltipProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </ErrorBoundary>
);
